import InvitationForm from "../../components/auth/InvitationForm";

const Invitation = () => {
  return (
    <>
      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">Complete registration</h1>
      <InvitationForm />
    </>
  )
}

export default Invitation;
